import { NgModule } from '@angular/core';
import { ClampNumberPipe } from './clamp-number.pipe';


@NgModule({
    imports: [],
    exports: [ClampNumberPipe],
    declarations: [ClampNumberPipe],
    providers: [],
})
export class ClampNumberPipeModule { }
